<script>
import {defineComponent, reactive} from "vue";
import {useLandingPageStore} from "../../stores/landingPage";

export default defineComponent({
  name: "ResourceDisplay",
  props: {
    /**
     * Resource Id of the image
     * Uses resource array in landing store to populate
     */
    resourceId: {
      type: Number,
      required: false
    },
    /**
     * The alt attribute for the image.
     */
    alt: {
      type: String,
      default: ''
    }
  },
  setup(props) {
    props = reactive(props);
    const landingStore = useLandingPageStore();

    return {
      landingStore
    };
  },
  data() {
    return {};
  },
  computed: {
    resourceSrc() {
      if (!this.resourceId) return null;
      return this.landingStore.getResourceById(this.resourceId)?.resource_url;
    },
    resourceType() {
      if (!this.resourceId) return null;
      return this.landingStore.getResourceById(this.resourceId)?.resource_type;
    }
  },
  methods: {},
});
</script>

<template>
  <div
    v-if="resourceId"
    class="resource-display-container"
  >
    <img
      v-if="resourceType === 'image' || resourceType === 'svg'"
      :key="resourceId"
      :src="resourceSrc"
      :alt="alt"
      onload="this.style.opacity=1"
    >
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/_variables.scss';

.resource-display-container {
  @apply flex-grow flex h-full w-full;
  img {
    @apply w-full h-full max-h-full overflow-hidden;
    object-fit: cover;
    opacity: 0;
    transition: all .4s ease;
    -webkit-transition: all .2s ease;
    -moz-transition: all .2s ease;
    -ms-transition: all .2s ease;
    -o-transition: all .2s ease;
  }
}
</style>
